export const isObjectValue = <TObject extends object>(
  object: TObject,
  value: unknown,
): value is TObject[keyof TObject] => {
  return Object.values(object).includes(value);
};
